import { parseISO, format } from 'date-fns';

const getMonth = (dateISOString: string) => {
  const parsedDate = parseISO(dateISOString);

  return format(parsedDate, 'MMMM');
};

export default getMonth;
